export const siteConfig = {
  companyName: "OneSaaS Office Management System",
  shortName: "OOMS",
  tagline: "The Ultimate Cloud ERP & CRM for Tax & Accounting Professionals",
  description: "Automate task management, client relationships, staff attendance, billing, and bulk communications on India's most secure cloud-based office management platform built for CAs, CSs, CMAs, Advocates, and Tax Consultants.",
  websiteUrl: "https://ooms.in",
  loginUrl: "https://app.ooms.in/login",
  registerUrl: "https://app.ooms.in/register",
  portalUrls: {
    app: "https://app.ooms.in",
    client: "https://client.ooms.in",
    ca: "https://ca.ooms.in",
  },
  email: [
    {
      type: "sale",
      email: "sales@ooms.in",
    },
    {
      type: "technical",
      email: "support@ooms.in",
    },
    {
      type: "general",
      email: "info@ooms.in",
    },
  ],
  phone: [
    {
      type: "sale",
      phone: "+91 98765 43210",
    },
    {
      type: "technical",
      phone: "+91 98765 43210",
    },
    {
      type: "general",
      phone: "+91 98765 43210",
    },
  ],
  whatsapp: [
    {
      type: "sale",
      whatsapp: "+91 98765 43210",
    },
    {
      type: "technical",
      whatsapp: "+91 98765 43210",
    },
    {
      type: "general",
      whatsapp: "+91 98765 43210",
    },
  ],
  whatsappMessage: "Hi OOMS team, I am interested in scheduling a live demo of the Office Management System. Please assist.",
  address: [
    {
      type: "head office",
      address:
        "OneSaaS Technologies Pvt. Ltd., 4th Floor, Innovation Wing, Koramangala Inner Ring Road, Bengaluru, Karnataka - 560034",
    },
    {
      "type": "branch office",
      "address": "123, Main Street, Anytown, USA"
    },
    {
      "type": "branch office",
      "address": "123, Main Street, Anytown, USA"
    }

  ],
  googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.7505295982845!2d77.62211937573539!3d12.923773115934509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14878a87b5a1%3A0xc3ec5bf87eb098b6!2sKoramangala%2C%20Bengaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin",
  businessHours: {
    weekdays: "Monday - Friday: 9:00 AM - 6:30 PM IST",
    saturday: "Saturday: 9:00 AM - 2:00 PM IST",
    sunday: "Sunday: Closed",
  },
  socialLinks: {
    linkedin: "https://linkedin.com/company/ooms-onesaas",
    twitter: "https://twitter.com/ooms_onesaas",
    facebook: "https://facebook.com/ooms.onesaas",
    youtube: "https://youtube.com/c/ooms-onesaas",
  },
  services: [
    {
      id: "client-management-crm",
      title: "Client Relationship Management (CRM)",
      shortDesc: "Centralize your client information, historical records, and filing statuses in a secure cloud database.",
      longDesc: "Manage all aspects of your clients' records from one unified CRM module. OOMS enables tax practitioners, Chartered Accountants, and Advocates to digitize client folders, store demographic information, maintain PAN/GSTIN registries, track individual filing histories, and categorize clients by vertical or service requirements.",
      features: [
        "Comprehensive client profile records with custom tags",
        "GSTIN, PAN, TAN, and ITR category registry with bulk validity checks",
        "Direct link between clients and assigned staff members",
        "Client logs for communications, notes, and activity histories",
      ],
      benefits: [
        "Eliminate paper client folders and lost paperwork",
        "Retrieve client KYC details and historical interactions in seconds",
        "Segment clients easily for tailored tax advice or compliance reminders",
      ],
      iconName: "Users",
      path: "/services/client-management-crm",
    },
    {
      id: "task-workflow-automation",
      title: "Task & Workflow Automation",
      shortDesc: "Automate and track recurring statutory tasks like GST, ITR, TDS, and Audit deadlines.",
      longDesc: "Stop relying on spreadsheets or mental checklists. The OOMS Task and Workflow module lets you set up automatic templates for recurring returns (monthly GST, quarterly TDS, annual audits). Managers can set milestones, assign sub-tasks, delegate to juniors, monitor progress in real-time, and run multi-level review approvals before final filing.",
      features: [
        "Recurring task generation based on standard Indian tax calendars",
        "Dynamic task statuses (Not Started, In Progress, Client Pending, Under Review, Completed)",
        "Sub-task creation, checklist enforcement, and custom milestones",
        "Multi-stage review pipelines (Article Clerk -> Manager -> Partner)",
      ],
      benefits: [
        "Never miss a filing deadline, protecting your clients from late fees",
        "Real-time visual monitoring of office capacity and bottleneck detection",
        "Enforce standardization across complex filings with strict checklists",
      ],
      iconName: "CheckSquare",
      path: "/services/task-workflow-automation",
    },
    {
      id: "staff-attendance-timesheets",
      title: "Staff Attendance & Timesheets",
      shortDesc: "Monitor office productivity, timesheets, and staff check-ins through individual logins.",
      longDesc: "Optimize resource utilization and manage team productivity. With dedicated portal credentials, your team can check in daily, record precise hours spent on specific client tasks, submit digital timesheets, and log out-of-office client visits. Partners get full dashboard analytics detailing exact time cost per filing, billable vs non-billable hours, and team capacity.",
      features: [
        "Secure individual staff login credentials with configurable access roles",
        "Daily attendance log with Web Punch-In/Out and location options",
        "Task-based timesheet logging with automated hours accumulation",
        "Analytics reports on staff workload, idle time, and task efficiency",
      ],
      benefits: [
        "Calculate exact profit margins per client and service",
        "Monitor article clerk activity and overall office productivity remotely",
        "Streamline monthly payroll processing with auto-generated attendance logs",
      ],
      iconName: "Clock",
      path: "/services/staff-attendance-timesheets",
    },
    {
      id: "expense-billing-management",
      title: "Finance & Invoicing System",
      shortDesc: "Generate professional invoices, track expenses, and automate outstanding payment alerts.",
      longDesc: "Improve cash flow with professional billing and automated collection workflows. OOMS tracks out-of-pocket expenses incurred during client representations, merges them into standard digital invoices, and enables payment links. Send auto-reminders for outstanding fees, accept online payments, and keep your firm's internal books in perfect order.",
      features: [
        "Professional invoicing templates with automated GST calculations",
        "Out-of-pocket and travel expense ledger mapped to specific client jobs",
        "Automatic email/WhatsApp payment reminders for unpaid invoices",
        "Billing dashboards displaying outstanding receivables, cash flow, and monthly revenue",
      ],
      benefits: [
        "Reduce collection cycles and outstanding debts by up to 40%",
        "Prevent unbilled out-of-pocket expenses from slipping through the cracks",
        "Professionalize your billing system with neat, digital, tax-compliant invoices",
      ],
      iconName: "CreditCard",
      path: "/services/expense-billing-management",
    },
    {
      id: "broadcast-communication-tools",
      title: "WhatsApp & Broadcast Tools",
      shortDesc: "Send bulk alerts, filing due dates, and greetings via WhatsApp, SMS, and Email.",
      longDesc: "Keep your clients informed and compliant. OOMS integrates smart broadcasting capabilities, allowing you to send targeted notifications to clients based on service type. Send automated WhatsApp reminders for due dates, gather missing documents, broadcast regulatory news alerts, or send festive greetings in one click.",
      features: [
        "Integrated WhatsApp API broadcasting to clients' mobile numbers",
        "Targeted client lists filtered by service category or filing pending status",
        "Pre-approved templates for statutory due dates, outstanding fees, and tax updates",
        "Multi-channel support: Whatsapp, SMS, and Email dispatched simultaneously",
      ],
      benefits: [
        "Drastically increase client response times compared to ignored emails",
        "Position your firm as a tech-forward partner with proactive updates",
        "Save manual follow-up time by automating broad notifications",
      ],
      iconName: "MessageSquare",
      path: "/services/broadcast-communication-tools",
    },
    {
      id: "secure-document-vault",
      title: "Secure Cloud Document Vault",
      shortDesc: "Store, organize, and retrieve client returns, digital certificates, and KYC securely.",
      longDesc: "Say goodbye to scattered files across physical computers or unsafe shared drives. The OOMS Secure Document Vault provides a structured cloud storage space for every client. Upload copies of IT acknowledgements, tax audit reports, registration certificates, digital signatures, and accounting statements, accessible from any device.",
      features: [
        "Structured, per-client nested folders for organized document storage",
        "Secure cloud backups with high-grade encryption protocols",
        "Upload and store large files (PDFs, Excel sheets, XML files, images)",
        "Granular file access control for partners, staff, and clients",
      ],
      benefits: [
        "Access client documents 24/7 from home, office, or client meetings",
        "Prevent accidental data loss from local hard drive failures",
        "Maintain clean data hygiene and compliance with bank-grade security",
      ],
      iconName: "Shield",
      path: "/services/secure-document-vault",
    },
  ],
  industries: [
    {
      id: "chartered-accountants",
      name: "Chartered Accountants (CAs)",
      desc: "Streamline comprehensive audit tasks, track complex tax audits, and manage article clerks under a unified hierarchy.",
      features: [
        "Article clerk timesheet approval pipelines",
        "Audit check-lists and documentation logs",
        "Tax audit deadline tracking with automatic client alerts",
      ],
      iconName: "Briefcase",
    },
    {
      id: "company-secretaries",
      name: "Company Secretaries (CS)",
      desc: "Keep up with ROC filings, corporate governance deadlines, minute book registries, and annual compliance schedules.",
      features: [
        "ROC event-based filing checklists",
        "Incorporation documentation manager",
        "Board meeting schedules and resolution databases",
      ],
      iconName: "BookOpen",
    },
    {
      id: "tax-consultants",
      name: "Tax Consultants & GST Practitioners",
      desc: "Automate high-volume monthly GST filings, quarterly TDS schedules, and individual income tax returns.",
      features: [
        "Bulk GSTIN return status check dashboards",
        "Automated WhatsApp broadcasting for due dates",
        "TDS filing tracking and client challan management",
      ],
      iconName: "FileText",
    },
    {
      id: "advocates-lawyers",
      name: "Advocates & Legal Practitioners",
      desc: "Manage case files, track hearing dates, store client petitions, and log billable litigation hours.",
      features: [
        "Hearing date reminder system",
        "Client petition and legal document drafts vault",
        "Case-by-case expense and retainership fee ledger",
      ],
      iconName: "Scale",
    },
    {
      id: "cost-accountants",
      name: "Cost Accountants (CMAs)",
      desc: "Coordinate cost audits, inventory valuations, and statutory cost compliance across manufacturing and service clients.",
      features: [
        "Cost audit checklist templates and milestone tracking",
        "Client-wise working paper and annexure vault",
        "Staff timesheets mapped to cost assignments",
      ],
      iconName: "Calculator",
    },
    {
      id: "corporate-finance-firms",
      name: "Corporate Finance & Accounting Firms",
      desc: "Scale your external bookkeeping and outsourced CFO workflows, handling client portfolios with enterprise efficiency.",
      features: [
        "Bookkeeping checklist standard operating procedures (SOPs)",
        "Client financial performance dashboarding",
        "Integrated multi-firm consolidated work views",
      ],
      iconName: "Building",
    },
  ],
  testimonials: [
    {
      id: "t1",
      name: "CA Ramesh Sharma",
      role: "Senior Partner",
      firm: "Sharma & Associates CAs",
      text: "Switching our office management to OOMS was the best business decision we made. We have 12 article clerks and 1500+ clients; tracking returns on Excel sheets was a nightmare. OOMS automated our task checklists and late filings dropped to zero.",
      rating: 5,
    },
    {
      id: "t2",
      name: "CS Ananya Mehta",
      role: "Founder",
      firm: "Mehta Corporate Compliance Services",
      text: "The ROC calendars and event-based checklists are outstanding. My team logs timesheets daily, and I can bill clients accurately based on the exact hours spent. OOMS has boosted our operational efficiency by at least 45%.",
      rating: 5,
    },
    {
      id: "t3",
      name: "Adv. Vikramaditya Sen",
      role: "Managing Advocate",
      firm: "Sen & Sen Legal Chamber",
      text: "Client trust is paramount for lawyers, and data security is our biggest concern. OOMS's encrypted document vault and secure role-based access gave us the confidence to take our legal practice to the cloud. Recommended for every law office.",
      rating: 5,
    },
    {
      id: "t4",
      name: "Amit Patel",
      role: "Founder & Tax Consultant",
      firm: "Patel Tax Services",
      text: "The WhatsApp Broadcasting tool is worth the subscription price alone! I can filter all clients whose GST filings are pending and send them a automated due date reminder in one click. Clients reply immediately and send documents.",
      rating: 5,
    },
  ],
  faqs: [
    {
      category: "general",
      question: "What is OOMS, and who is it designed for?",
      answer: "OOMS (OneSaaS Office Management System) is a secure, cloud-based ERP and CRM designed specifically for professional services firms in India, including Chartered Accountants (CAs), Company Secretaries (CSs), Cost Accountants (CMAs), Tax Practitioners, Advocates, and accounting firms.",
    },
    {
      category: "general",
      question: "Is there a desktop software installation required?",
      answer: "No, OOMS is a 100% cloud-native SaaS application. You do not need to install any heavy software. You can access it securely from any modern web browser on your laptop, desktop, tablet, or smartphone.",
    },
    {
      category: "general",
      question: "Can we run multiple branches or offices under one account?",
      answer: "Yes. OOMS supports unlimited branch creation so partners can segregate teams, clients, and billing by location while retaining a consolidated view at the firm level.",
    },
    {
      category: "features",
      question: "How does the WhatsApp Broadcast feature work?",
      answer: "OOMS integrates directly with official messaging gateways, enabling you to select specific groups of clients (e.g., GST-pending clients) and broadcast customized reminders, due-date notices, or documents directly to their WhatsApp numbers. This helps firms bypass ignored emails and speed up client updates.",
    },
    {
      category: "features",
      question: "Can I manage staff attendance and check-in times?",
      answer: "Yes. OOMS provides separate login accounts for every employee. Employees can log attendance via Web Punch-In, submit detailed daily timesheets explaining hours spent on specific client tasks, and request leaves. Partners get full dashboard transparency into staff workloads.",
    },
    {
      category: "features",
      question: "Do clients get their own portal access?",
      answer: "Client portals can be enabled so clients review assigned work status, share documents, and receive structured updates without exposing your internal staff workflows.",
    },
    {
      category: "security",
      question: "How secure is my clients' sensitive financial data?",
      answer: "We treat security as our highest priority. All data transmitted to OOMS is encrypted using bank-grade 256-bit SSL encryption. Data is stored on secure, highly redundant cloud servers with ISO 27001 data center compliances, physical security, and regular automatic backups.",
    },
    {
      category: "security",
      question: "Can I control which client files my junior staff can see?",
      answer: "Absolutely. OOMS implements granular, role-based access control (RBAC). You can define user roles (Partner, Manager, Senior, Junior, Article Clerk) and restrict access to sensitive financial metrics, billing modules, or specific premium client profiles.",
    },
    {
      category: "security",
      question: "Can we export our data if we leave the platform?",
      answer: "Yes. You retain ownership of your firm data. OOMS supports structured exports of clients, tasks, and documents so you are never locked into a proprietary silo.",
    },
    {
      category: "pricing",
      question: "What subscription options are available, and is there a free trial?",
      answer: "OOMS offers flexible plans on 1-month, 3-month, 6-month, and 12-month cycles. We offer a 7-day risk-free trial of premium features, and our sales team is happy to schedule a customized live demo.",
    },
    {
      category: "pricing",
      question: "Are there per-user fees or setup charges?",
      answer: "No. Plans include unlimited user creation and unlimited branch creation with a flat subscription — no hidden per-seat fees or mandatory setup charges.",
    },
    {
      category: "onboarding",
      question: "How do we migrate from Excel or another tool?",
      answer: "Most firms import client registries (PAN, GSTIN, contacts) via spreadsheet templates, then invite staff and deploy recurring task workflows. Longer plans include guided onboarding assistance from our team.",
    },
    {
      category: "onboarding",
      question: "How long does it take to go live?",
      answer: "Many practices complete core setup — branches, users, client import, and first workflows — within a single working day. Complex multi-office rollouts typically finish within a week with our guided checklist.",
    },
  ],
  stats: [
    {
      label: "Active Firms Trusting Us",
      value: "15K+",
      numericValue: 15000,
      suffix: "+",
    },
    {
      label: "Tasks & Return Filings Automated",
      value: "5M+",
      numericValue: 5,
      suffix: "M+",
    },
    {
      label: "Active Staff & Client Portals",
      value: "150K+",
      numericValue: 150000,
      suffix: "+",
    },
    {
      label: "Server Architecture Uptime",
      value: "99.99%",
      numericValue: 99.99,
      suffix: "%",
    },
  ],
  trustIndicators: [
    {
      title: "ISO 27001 Certified",
      description: "Adhering to strict international standards for information security management.",
      iconName: "ShieldCheck",
    },
    {
      title: "GDPR Compliant",
      description: "Data privacy practices designed to protect user identity and proprietary files.",
      iconName: "UserCheck",
    },
    {
      title: "Bank-Grade Encryption",
      description: "Active 256-bit SSL encryption safeguards all data transmission and database storage.",
      iconName: "Lock",
    },
    {
      title: "100% Made in India",
      description: "Designed specifically to address Indian compliance, GST calendars, and taxation workflows.",
      iconName: "Flag",
    },
  ],
  teamMembers: [
    {
      id: 1,
      name: "Mubarak Ali",
      designation: "Founder & CEO",
      image: "/mubarak.jpeg",
      bio: "Visionary leader driving innovation, client success, and long-term product strategy for professional firms.",
      linkedin: "",
      email: "",
    },
    {
      id: 2,
      name: "Sourav Kr Adhikary",
      designation: "Lead Developer",
      image: "/sourav.jpeg",
      bio: "Leading product engineering, scalable software architecture, and secure cloud delivery for the OOMS platform.",
      linkedin: "",
      email: "",
    },
  ],
  pricingPlans: [
    {
      id: "silver",
      name: "Silver",
      price: 999,
      currency: "₹",
      duration: "month",
      durationLabel: "1 Month",
      description: "Ideal for individual practitioners starting their digital journey.",
      features: [
        { text: "Unlimited users & branches", included: true },
        { text: "Full CRM + task workflows", included: true },
        { text: "Staff attendance & timesheets", included: true },
        { text: "Invoicing & document vault", included: true },
        { text: "WhatsApp / SMS / Email broadcast", included: true },
        { text: "Standard email support", included: true },
        { text: "Guided onboarding call", included: false },
        { text: "Priority support SLA", included: false },
      ],
      ctaText: "Start 1 Month Plan",
      ctaLink: "/contact?plan=silver",
    },
    {
      id: "gold",
      name: "Gold",
      price: 2799,
      currency: "₹",
      duration: "3-months",
      durationLabel: "3 Months",
      description: "Best for small firms looking to stabilize their digital workflows.",
      features: [
        { text: "Everything in Silver", included: true },
        { text: "3-month billing savings", included: true },
        { text: "Recurring GST / TDS templates", included: true },
        { text: "Multi-channel reminders", included: true },
        { text: "Standard email support", included: true },
        { text: "1 guided setup session", included: true },
        { text: "Dedicated success manager", included: false },
        { text: "Priority support SLA", included: false },
      ],
      ctaText: "Start 3 Month Plan",
      ctaLink: "/contact?plan=gold",
    },
    {
      id: "platinum",
      name: "Platinum",
      price: 5399,
      currency: "₹",
      duration: "6-months",
      durationLabel: "6 Months",
      description: "The professional choice for growing firms with multiple departments.",
      isPopular: true,
      features: [
        { text: "Everything in Gold", included: true },
        { text: "Best mid-term value", included: true },
        { text: "Priority chat & email support", included: true },
        { text: "Multi-branch rollout checklist", included: true },
        { text: "2 onboarding workshops", included: true },
        { text: "Migration from Excel assist", included: true },
        { text: "Quarterly usage review", included: true },
        { text: "Dedicated success manager", included: false },
      ],
      ctaText: "Start 6 Month Plan",
      ctaLink: "/contact?plan=platinum",
    },
    {
      id: "diamond",
      name: "Diamond",
      price: 9999,
      currency: "₹",
      duration: "year",
      durationLabel: "12 Months",
      description: "Maximum value for large enterprise firms seeking total office automation.",
      features: [
        { text: "Everything in Platinum", included: true },
        { text: "Lowest annual cost / month", included: true },
        { text: "Dedicated success manager", included: true },
        { text: "Priority support SLA", included: true },
        { text: "Full data migration package", included: true },
        { text: "Custom workflow templates", included: true },
        { text: "Quarterly strategy reviews", included: true },
        { text: "Early access to new modules", included: true },
      ],
      ctaText: "Start 12 Month Plan",
      ctaLink: "/contact?plan=diamond",
    },
  ],
  howItWorks: [
    {
      step: "01",
      title: "Create your firm workspace",
      desc: "Register, set branch details, and invite partners with role-based access from day one.",
      iconName: "Building2",
    },
    {
      step: "02",
      title: "Import clients & KYC",
      desc: "Bulk-upload PAN, GSTIN, contacts, and tags so every filing starts from a clean registry.",
      iconName: "Upload",
    },
    {
      step: "03",
      title: "Automate recurring tasks",
      desc: "Deploy GST, TDS, ITR, and audit templates with checklists, reviewers, and deadlines.",
      iconName: "ClipboardList",
    },
    {
      step: "04",
      title: "Broadcast & collect",
      desc: "Send WhatsApp, SMS, and email reminders, then invoice and track receivables in one place.",
      iconName: "Send",
    },
    {
      step: "05",
      title: "Monitor & scale",
      desc: "Use dashboards for staff capacity, branch performance, and cash flow as you grow.",
      iconName: "TrendingUp",
    },
  ],
  integrations: [
    {
      id: "whatsapp",
      title: "WhatsApp Business API",
      desc: "Approved templates for due dates, document requests, and payment follow-ups.",
      iconName: "MessageSquare",
    },
    {
      id: "sms",
      title: "SMS / Fast2SMS",
      desc: "Reach clients instantly with DLT-ready transactional and reminder SMS.",
      iconName: "Smartphone",
    },
    {
      id: "email",
      title: "Company Email / SMTP",
      desc: "Send branded notices and invoices from your firm domain.",
      iconName: "Mail",
    },
    {
      id: "razorpay",
      title: "Razorpay Payments",
      desc: "Accept UPI and card payments against invoices and wallet top-ups.",
      iconName: "CreditCard",
    },
    {
      id: "call",
      title: "System Call Channel",
      desc: "Optional PBX-backed call workflows for high-touch client follow-ups.",
      iconName: "Phone",
    },
    {
      id: "storage",
      title: "Encrypted Cloud Vault",
      desc: "Store returns, DSC copies, and KYC with structured per-client folders.",
      iconName: "HardDrive",
    },
  ],
  securityHighlights: [
    {
      title: "256-bit SSL in transit",
      description: "Every browser session and API call is encrypted end-to-end.",
      iconName: "Lock",
    },
    {
      title: "Role-based access control",
      description: "Partners decide exactly what managers, seniors, and article clerks can view.",
      iconName: "ShieldCheck",
    },
    {
      title: "Isolated firm data",
      description: "Tenant isolation keeps your client folders scoped to your workspace only.",
      iconName: "Database",
    },
    {
      title: "Session & device hygiene",
      description: "Active session controls help you end unused logins across devices.",
      iconName: "Smartphone",
    },
    {
      title: "Automated backups",
      description: "Redundant cloud storage with routine backups protects against local disk loss.",
      iconName: "Cloud",
    },
    {
      title: "India-first compliance UI",
      description: "Built around GST calendars, Indian tax workflows, and professional firm hierarchies.",
      iconName: "Flag",
    },
  ],
  resourceArticles: [
    {
      slug: "automate-gst-workflows-for-ca-firms",
      title: "How CA Firms Automate Monthly GST Workflows with OOMS",
      excerpt: "Replace spreadsheet trackers with recurring GSTR templates, review pipelines, and client reminders.",
      category: "Workflows",
      readMinutes: 6,
      publishedAt: "2025-11-12",
      keywords: ["GST", "CA firm", "task automation"],
      content: [
        "Monthly GST season stretches teams thin when deadlines live in shared Excel sheets. OOMS lets you generate recurring GSTR-related tasks from Indian tax calendars, assign article clerks, and enforce multi-level review before filing.",
        "Filter clients by GSTIN status, attach checklists for reconciliations, and broadcast WhatsApp or SMS reminders to clients who still owe documents. Partners see real-time bottlenecks instead of chasing status on chat threads.",
        "Firms that move GST work into OOMS typically cut missed filings and free senior time for advisory work — while juniors follow a consistent SOP every cycle.",
      ],
    },
    {
      slug: "timesheets-that-improve-billing-accuracy",
      title: "Timesheets That Actually Improve Billing Accuracy",
      excerpt: "Map staff hours to client tasks so retainers and job-wise invoices reflect real effort.",
      category: "Productivity",
      readMinutes: 5,
      publishedAt: "2025-12-03",
      keywords: ["timesheets", "billing", "attendance"],
      content: [
        "Professional firms often underbill because hours are estimated at month-end. With OOMS, every punch-in and task log rolls into client-wise timesheets partners can audit before invoicing.",
        "Article clerks record time against specific returns or litigation matters. Managers spot idle capacity early. Finance merges out-of-pocket expenses into the same job ledger.",
        "Accurate timesheets also strengthen performance reviews and help you price fixed-fee packages with confidence.",
      ],
    },
    {
      slug: "whatsapp-compliance-reminders-that-clients-open",
      title: "WhatsApp Compliance Reminders Clients Actually Open",
      excerpt: "Use approved templates and smart client filters so due-date notices cut through inbox noise.",
      category: "Communications",
      readMinutes: 5,
      publishedAt: "2026-01-18",
      keywords: ["WhatsApp", "broadcast", "compliance"],
      content: [
        "Email open rates for tax notices are notoriously low. OOMS connects to WhatsApp Business workflows so you can target only GST-pending or ITR-pending clients with a single broadcast.",
        "Combine templates for document requests, fee reminders, and festive greetings without leaving the CRM. Multi-channel dispatch (WhatsApp, SMS, email) covers clients who prefer different channels.",
        "The result: faster document collection, fewer last-day surprises, and a more professional client experience.",
      ],
    },
    {
      slug: "securing-client-documents-in-the-cloud",
      title: "Securing Client Documents in the Cloud Without Losing Speed",
      excerpt: "Why encrypted vaults with RBAC beat shared drives for CA, CS, and legal practices.",
      category: "Security",
      readMinutes: 7,
      publishedAt: "2026-02-09",
      keywords: ["document vault", "security", "RBAC"],
      content: [
        "Shared folders on office PCs create version chaos and access risk. OOMS organizes KYC, acknowledgements, and working papers in per-client vaults with encryption in transit and role-based permissions.",
        "Partners can restrict billing modules or VIP clients from junior logins while still enabling staff to upload day-to-day filings. Session controls help you revoke access when devices change hands.",
        "Cloud availability means partners retrieve files from client meetings without VPN gymnastics — without sacrificing the confidentiality your profession demands.",
      ],
    },
    {
      slug: "migrating-from-excel-to-ooms",
      title: "Migrating From Excel to OOMS in One Working Day",
      excerpt: "A practical checklist to import clients, invite staff, and launch your first workflows.",
      category: "Onboarding",
      readMinutes: 6,
      publishedAt: "2026-03-01",
      keywords: ["migration", "Excel", "onboarding"],
      content: [
        "Start with a clean client export: names, PAN, GSTIN, mobiles, and service tags. OOMS import templates map these fields into the CRM so historical Excel rows become searchable profiles.",
        "Next, create branches, invite users with the right roles, and clone recurring task templates for your highest-volume services. Run a pilot on one vertical (for example GST) before expanding.",
        "Longer subscription plans include guided onboarding so your team is not guessing at best practices during the first week.",
      ],
    },
    {
      slug: "choosing-the-right-ooms-plan",
      title: "Choosing the Right OOMS Plan for Your Firm Size",
      excerpt: "Compare Silver through Diamond by onboarding depth, support, and annual value — not just sticker price.",
      category: "Pricing",
      readMinutes: 4,
      publishedAt: "2026-03-20",
      keywords: ["pricing", "plans", "subscription"],
      content: [
        "Every OOMS plan includes unlimited users and branches plus the core CRM, tasks, attendance, billing, broadcast, and vault modules. Differentiation sits in commitment length, savings, and success support.",
        "Solo practitioners often start on Silver or Gold to validate workflows. Growing multi-department firms benefit from Platinum workshops and Excel migration help. Large practices usually pick Diamond for a success manager and yearly reviews.",
        "Book a live demo if you are unsure — we map plan choice to your branch count, staff size, and filing volume.",
      ],
    },
  ],
  seoDefaults: {
    titleTemplate: "%s | OOMS - OneSaaS Office Management System",
    defaultTitle: "OOMS | Cloud Office Management System for CAs, CSs, and Tax Professionals",
    defaultDescription: "Simplify your practice with OOMS. Automate task tracking, client CRM, article clerk timesheets, billing, and WhatsApp broadcasting in one secure dashboard.",
    openGraph: {
      type: "website",
      locale: "en_IN",
      siteName: "OOMS OneSaaS",
    },
    twitter: {
      handle: "@ooms_onesaas",
      site: "@ooms_onesaas",
      cardType: "summary_large_image",
    },
  },
};
